import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Container = styled.div`
  grid-area: range;
  background-color: grey;
  margin: 0 0 25px 0;
  padding: 3px 20px 3px 20px;
  // height: 70px;
  
  align-items: center;
  justify-content: center;
  position: relative;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 15px 30px 0px 30px;
    padding: 10px 30px 10px 30px;
  }
`;

export const Wrapper = styled.div`

`;

export const InnerContainer = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 65px;
  align-self: center;
`;

export const LeftArrow = styled.div`
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 6px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  top: 18px;
  left: 7px;
  position: absolute;
`;

export const RightArrow = styled.div`
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 6px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  top: 18px;
  right: 7px;
  position: absolute;
`;

/** Ticks */
export const TickContainer = styled.div`

`;

export const TickLine = styled.div`
  position: absolute;
  margin-top: -25px;
  width: 1px;
  height: 26px;
  background-color: #8c8c8c;
  left: ${(props) => props.percent}%;
  margin-left: ${50 / 11 / 2}%;
  // margin-left: ${50 / ((props) => props.count) / 2}%;
  // margin-left: 2%;
  z-index: 1;
  @media (min-width: ${breakpoints.desktop}) {
    width: 3px;
    margin-left: ${50 / 12 / 2}%;
  }
`;

export const TickText = styled.div`
  position: absolute;
  margin-top: 6px;
  font-size: 10px;
  text-align: center;
  font-family: Roboto;
  margin-left: calc(-50 / ${(props) => props.count} / 2)%;
  width: calc(100 / ${(props) => props.count});
  left: ${(props) => props.percent}%;
  color: #8c8c8c;
  z-index: 1;
  
  @media (min-width: ${breakpoints.desktop}) {
    font-size: 14px;
  }
`;
